<template>
  <div>
    <label :for="id" v-if="label" class="label" v-html="`${label} ${required ? '*' : ''}`"></label>

    <SelectComp
      :selectable="(option) => !option.disabled"
      :id="id"
      :disabled="isDisabled"
      :options="options || []"
      :taggable="taggable"
      v-model="field"
      :placeholder="taggable ? 'Selecione ou digite uma cidade' : 'Selecione uma opção'"
    />
  </div>
</template>
<script>
export default {
  props: {
    value: {},
    id: {},
    label: {},
    options: {},
    required: {},
    isDisabled: {},
    taggable: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      field: ''
    }
  },

  mounted() {
    if (this.taggable && this.value) {
      // Se for taggable e tiver um valor, verifica se está nas opções
      const foundOption = this.options.find((item) => item?.value === this.value)
      if (foundOption) {
        this.field = foundOption
      } else {
        // Se não estiver nas opções, cria um objeto com o valor digitado
        this.field = { label: this.value, value: this.value }
      }
    } else {
      this.field = this.options.find((item) => item?.value === this.value) || ''
    }
  },

  watch: {
    value: {
      handler(value) {
        if (this.taggable && value) {
          const foundOption = this.options.find((item) => item?.value === value)
          if (foundOption) {
            if (this.$f.isEqual(foundOption, this.field)) return
            this.field = foundOption
          } else {
            // Se não estiver nas opções, cria um objeto com o valor digitado
            const customOption = { label: value, value: value }
            if (this.$f.isEqual(customOption, this.field)) return
            this.field = customOption
          }
        } else {
          if (this.$f.isEqual(value, this.field)) return
          this.field = this.options.find((item) => item?.value === value) || ''
        }
      }
    },

    field: {
      handler(field) {
        let fieldValue = ''
        if (field) {
          // Se field for um objeto, pega o value, senão usa o próprio valor
          if (typeof field === 'object' && field !== null) {
            fieldValue = field.value !== undefined ? field.value : (field.label || '')
          } else {
            fieldValue = field
          }
        }
        
        if (this.$f.isEqual(fieldValue, this.value)) return
        this.$emit('input', fieldValue)
      }
    }
  }
}
</script>
<style>
.vs__selected-options {
  box-sizing: border-box;
  white-space: nowrap;
  width: 100%;
  overflow: hidden;

  text-overflow: ellipsis;
}
.vs__search {
  box-sizing: border-box;
  max-height: 24px;
}
input::placeholder {
  color: #888 !important;
  font-weight: 400;
  font-size: 12px !important;
  opacity: 1;
}
</style>
